import { render, staticRenderFns } from "./missedPayments.vue?vue&type=template&id=5ab84a94&"
import script from "./missedPayments.vue?vue&type=script&lang=js&"
export * from "./missedPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports